import { IUploadInfo } from "views/bulkUpload/UploadCatalog/content/uploadCatalogInfo";

export const downloadUploadInfo: IUploadInfo = {
  title: 'Sube la plantilla actualizada',
  description: (
    <>
      Sube la plantilla en formato <strong>.xlsx</strong> para continuar con la carga masiva. Haz clic en “Subir
      plantilla” o arrástralo aquí. También puedes omitir este paso y subirlo después desde el Cargue masivo
    </>
  ),
  icon: 'document'
};

export const downloadUploadInfoWithErrors = (templateUrl: string): IUploadInfo => ({
  title: 'Sube la plantilla actualizada',
  description: (
    <div>
      <p style={{ margin: 0 }}>
        Sube nuevamente la plantilla una vez que resuelvas los errores. ¿No se descargó correctamente el archivo?
      </p>
      <a href={templateUrl}>Descargar plantilla con errores</a>
    </div>
  ),
  icon: 'document'
});
